import { RouterMount, createRouter } from 'uni-simple-router';
import { token } from '@/common/utils/token/token.js';

const router = createRouter({
	platform: process.env.VUE_APP_PLATFORM, 
	h5:{
		paramsToQuery: true
	},
	routes: [
		...ROUTES,
		{
			path: '*',
			redirect: (to) => {
				return {
					path: '/index/404'
				}
			}
		}
	]
});

//全局路由前置守卫
router.beforeEach((to, from, next) => {
	if(!uni.$sk.config.routes || Object.keys(uni.$sk.config.routes).length == 0) {
		for(let index in ROUTES) {
			uni.$sk.config.routes[ROUTES[index]['aliasPath']] = ROUTES[index];
		}
	}
	
	let userToken = token.get();
	if((to.meta.isLoginAuth !== 0 && to.meta.isLoginAuth !== false) && !userToken) {
		token.remove();
		let redirect = to.query.redirect ? to.query.redirect : to.fullPath;
		let pageName = uni.$sk.config.routes[uni.$sk.func.getLoginPath()].name;
		let pagePath = uni.$sk.config.routes[uni.$sk.func.getLoginPath()].aliasPath;
		return next({
			name: pageName,
			params: {
				redirect
			}
		});
	}
	
	next();
});

// 全局路由后置守卫
router.afterEach((to, from) => {
	if(!to.style.navigationBarTitleText) {
		setTimeout(() => {
			uni.setNavigationBarTitle({
				title: uni.$sk.config.pageTitle
			});
		}, 100);
	}
})

export {
	router,
	RouterMount
}